import { graphql, useStaticQuery } from "gatsby"
import React, { FC } from "react"

import "./MobileAppButtons.scss"
import ImageAboveFold from "@components/ImageAboveFold/ImageAboveFold"
import useCommonUrlsAndNumbers from "@hooks/useCommonUrlsAndNumbers"

const MobileAppButtons: FC = () => {
  const {
    appleAppStoreUrl,
    googlePlayStoreUrl,
  } = useCommonUrlsAndNumbers()

  const {
    appleAppStoreDownload,
    googlePlayDownload,
  } = useStaticQuery(graphql`
    query MobilePrefooterQuery {
      appleAppStoreDownload: contentfulAsset(
        contentful_id: {eq: "50XiZj0FzZ7i6Dhd93NPV2"}
      ) {
        imgixImage {
          gatsbyImageData(height: 40)
        }
      }
      googlePlayDownload: contentfulAsset(
        contentful_id: {eq: "1aHLhdI7sVs9NG8nyIdIys"}
      ) {
        imgixImage {
          gatsbyImageData(height: 40)
        }
      }
    }
  `)

  return (
    <div className="MobileAppButtons">
      {appleAppStoreDownload?.imgixImage?.gatsbyImageData && (
        <a href={appleAppStoreUrl || ""}>
          <ImageAboveFold
            alt="Download on the App Store"
            aspectRatio={120 / 40}
            imageData={appleAppStoreDownload.imgixImage.gatsbyImageData}
          />
        </a>
      )}
      {googlePlayDownload?.imgixImage?.gatsbyImageData && (
        <a href={googlePlayStoreUrl || ""}>
          <ImageAboveFold
            alt="Get it on Google Play"
            aspectRatio={135 / 40}
            imageData={googlePlayDownload.imgixImage.gatsbyImageData}
          />
        </a>
      )}
    </div>
  )
}

export default MobileAppButtons